import { common } from "./es/common";
import { auth } from "./es/auth";
import { onboarding } from "./es/onboarding";
import { profile } from "./es/profile";
import { settings } from "./es/settings";
import { matching } from "./es/matching";
import { chat } from "./es/chat";
import { company } from "./es/company";
import { events } from "./es/events";
import { checkin } from "./es/checkin";
import { miniApps } from "./es/mini-apps";
import { card } from "./es/card";
import { connect } from "./es/connect";
import { points } from "./es/points";
import { demo } from "./es/demo";
import { native } from "./es/native";
import { landing } from "./es/landing";
import { tags } from "./es/tags";
import { postMeetup } from "./es/post-meetup";

export const es = {
  ...common,
  ...auth,
  ...onboarding,
  ...profile,
  ...settings,
  ...matching,
  ...chat,
  ...company,
  ...events,
  ...checkin,
  ...miniApps,
  ...card,
  ...connect,
  ...points,
  ...demo,
  ...native,
  ...landing,
  ...tags,
  ...postMeetup,
};
